import {
  FACETS_GROUPS_CONFIG,
  FACETS_GROUPS_CONFIG_SHOP_5157,
} from 'site-modules/shared/constants/inventory/usurp-filters-config';

export function getGroupsConfig({ isShop5157Challenger }) {
  if (isShop5157Challenger) {
    return FACETS_GROUPS_CONFIG_SHOP_5157;
  }

  return FACETS_GROUPS_CONFIG;
}
